import { apiFetch } from './apiFetch';

export async function fetchCrowdExpressions() {
  const response = await apiFetch('/crowd/exp', {
    method: 'GET',
  });

  if (!response.ok) {
    throw new Error('اطلاعات دریافت نشد.');
  }

  const result = await response.json();

  if (Array.isArray(result)) {
    return result;
  }

  if (Array.isArray(result?.data)) {
    return result.data;
  }

  return [];
}

export async function likeCrowdExp(crowdExpId) {
  const response = await apiFetch(`/crowd/exp/like?exp_id=${crowdExpId}`, {
    method: 'PATCH',
  });

  if (!response.ok) {
    throw new Error('اطلاعات دریافت نشد.');
  }

  const result = await response.json();

  return Boolean(result.success);
}

export async function playCrowdExp(crowdExpId) {
  const response = await apiFetch(`/crowd/exp/play?exp_id=${crowdExpId}`, {
    method: 'PATCH',
  });

  if (!response.ok) {
    throw new Error('اطلاعات دریافت نشد.');
  }

  const result = await response.json();

  return Boolean(result.success);
}

export async function createCrowdExpression(
  firstName,
  city,
  recordingDuration,
  recordedAudioBlob,
) {
  try {
    const payload = new FormData();
    payload.append('name', firstName);
    payload.append('city', city);
    payload.append('duration', parseInt(recordingDuration, 10));
    payload.append('audio', recordedAudioBlob, 'recording.webm');

    const response = await apiFetch('/crowd/exp', {
      method: 'POST',
      body: payload,
    });

    if (!response.ok) {
      if (response.status == 429) {
        throw new Error('شما به سقف ثبت صدا برای امروز رسیدید.');
      }
      throw new Error('ثبت موفق نبود. لطفا مجدد تلاش فرمایید.');
    }
  } catch (error) {
    console.error('Error creating crowd expression: ', error);
    throw error;
  }
}
